import React from 'react'
import { BrowserRouter as Router,
  Route,
  NavLink
} from 'react-router-dom'


import BasePage from "Base/Page"
import RandomMapGenerator from "Components/util/RandomMapGenerator"
import RandomPathsGenerator from "Components/util/RandomPathsGenerator"
import Home from "Components/site/pages/tools/Home"
import LoginForm from "Components/util/LoginForm"

class Tools extends BasePage {
    render() {
        const is_logged_in = this.props.is_logged_in
        if ( true ) {
            return (
<Router>
<div className="tools_container">
    <nav>
        <div className="navigation_container">
        <NavLink className="tools_item" to="/tools/random_maps">Random height maps</NavLink>
        <NavLink className="tools_item" to="/tools/random_paths">Random paths</NavLink>
        <NavLink className="tools_item" to="/tools/home">about</NavLink>
        </div>
    </nav>
    <Route path="/tools/home" component={Home}/>
    <Route path="/tools/random_maps" component={RandomMapGenerator}/>
    <Route path="/tools/random_paths" component={RandomPathsGenerator}/>
</div>
</Router>
            )
        } else {
            return (<LoginForm/>)
        }
    }
}

export default Tools



// WEBPACK FOOTER //
// ./src/lib/components/site/pages/Tools.js